// src/components/common/contentloader/NamespaceSkeleton.jsx
import { Box, Card } from "@mui/material";
import { keyframes } from "@mui/system";

const shimmer = keyframes`
  0%   { background-position: -600px 0; }
  100% { background-position:  600px 0; }
`;

const Sk = ({ w, h = 12, br = 6, mb = 0 }) => (
  <Box sx={{
    width: w, height: h, borderRadius: `${br}px`, mb: mb ? `${mb}px` : 0, flexShrink: 0,
    background: "linear-gradient(90deg, #e2e8f0 25%, #f1f5f9 50%, #e2e8f0 75%)",
    backgroundSize: "600px 100%",
    animation: `${shimmer} 1.4s infinite`,
  }} />
);

const SkCard = ({ children, sx = {} }) => (
  <Card sx={{ border: "1px solid #e2e8f0", boxShadow: "0 1px 3px 0 rgb(0 0 0/0.06)", ...sx }}>
    <Box sx={{ p: "18px 20px" }}>{children}</Box>
  </Card>
);

const TableRow = ({ nameWidth, last = false }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 2, p: "14px 18px", borderBottom: last ? "none" : "1px solid #f1f5f9" }}>
    <Sk w={36} h={36} br={9} />
    <Sk w={nameWidth} />
    <Box sx={{ flex: 1 }}><Sk w="100%" h={7} br={20} mb={5} /><Sk w={80} h={9} /></Box>
    <Box sx={{ flex: 1 }}><Sk w="100%" h={7} br={20} mb={5} /><Sk w={80} h={9} /></Box>
    <Sk w={60} />
    <Sk w={50} />
  </Box>
);

export default function NamespaceSkeleton() {
  return (
    <Box sx={{ p: 3, bgcolor: "#f5f7fa" }}>

      {/* Header with aggregate selector */}
      <SkCard sx={{ mb: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Sk w={46} h={46} br={12} />
            <Box><Sk w={180} h={16} mb={8} /><Sk w={120} /></Box>
          </Box>
          <Sk w={140} h={36} br={10} />
        </Box>
      </SkCard>

      {/* Stat cards */}
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 1.5, mb: 2 }}>
        {[[70, 40], [80, 55], [90, 50], [100, 45]].map(([lw, vw], i) => (
          <SkCard key={i}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <Box><Sk w={lw} mb={10} /><Sk w={vw} h={24} /></Box>
              <Sk w={38} h={38} br={10} />
            </Box>
          </SkCard>
        ))}
      </Box>

      {/* Toolbar */}
      <Box sx={{ bgcolor: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "10px", p: 2, mb: 2, display: "flex", gap: 1.5, flexWrap: "wrap", alignItems: "flex-end" }}>
        <Sk w={220} h={34} br={6} />
        <Sk w={130} h={34} br={6} />
        <Sk w={20} h={20} br={4} />
        <Sk w={130} h={34} br={6} />
        <Sk w={90} h={34} br={6} />
      </Box>

      {/* Table */}
      <Card sx={{ border: "1px solid #e2e8f0", p: 0, overflow: "hidden" }}>
        <Box sx={{ display: "flex", gap: 2.5, p: "10px 18px", borderBottom: "1px solid #e2e8f0" }}>
          {[80, 90, 100, 80, 80].map((w, i) => <Sk key={i} w={w} h={10} />)}
        </Box>
        <TableRow nameWidth={110} />
        <TableRow nameWidth={90} />
        <TableRow nameWidth={130} last />
      </Card>
    </Box>
  );
}